import { useState } from 'react';
import { faqs } from '@/mocks/movies';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100">
      <div className="mx-auto max-w-[900px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="常见问题"
          title="关于 555电影片库的常见疑问"
          desc="把大家最常问的几个问题整理在这里，帮你更快了解站点的内容范围与使用方法。"
          align="center"
        />

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? 'border-primary-300 bg-primary-50' : 'border-background-200 bg-background-50'
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : index)}
                    aria-expanded={open}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-base font-bold text-foreground-950">{item.q}</span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? 'bg-accent-500 text-background-50' : 'bg-background-100 text-foreground-600'
                      }`}
                    >
                      <i className={open ? 'ri-subtract-line text-lg' : 'ri-add-line text-lg'}></i>
                    </span>
                  </button>
                </h3>
                <div className={`px-5 pb-5 ${open ? '' : 'hidden'}`}>
                  <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}